import { Result, Button } from 'antd';
import { useNavigate, useRouteError, isRouteErrorResponse } from 'react-router-dom';

interface ErrorFallbackProps {
  error?: Error | { message: string };
}

export function ErrorFallback({ error }: ErrorFallbackProps) {
  const navigate = useNavigate();
  const routeError = useRouteError();

  let title = 'Something went wrong';
  let message = error?.message || 'An unexpected error occurred. Please try again.';
  let status: 'error' | '404' | '403' | '500' = 'error';

  if (isRouteErrorResponse(routeError)) {
    if (routeError.status === 404) {
      title = 'Page Not Found';
      message = 'The page you are looking for does not exist.';
      status = '404';
    } else if (routeError.status === 403) {
      title = 'Access Denied';
      message = 'You do not have permission to access this page.';
      status = '403';
    } else {
      message = routeError.statusText || message;
    }
  } else if (routeError instanceof Error) {
    message = routeError.message;
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Result
        status={status === 'error' ? 'error' : status}
        title={title}
        subTitle={message}
        extra={[
          <Button key="back" onClick={() => navigate(-1)}>
            Go Back
          </Button>,
          <Button key="home" type="primary" onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </Button>,
        ]}
      />
    </div>
  );
}
